<!-- 动态数据面板 -->
<template>
    <div v-if="componentsData.type == 29">
        <div
            class="panel bg-div"
            :style="{
                ...(componentsData.content.bg_color && {
                    backgroundColor: componentsData.content.bg_color,
                }),
                ...(componentsData.content.bg_img &&
                    componentsData.content.bg_img.picview &&
                    componentsData.content.bg_value && {
                        backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                    }),
                padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
            }"
        >
            <!-- 标题 -->
            <div
                class="title-row"
                :style="{
                    background: componentsData.content.title_bg_color,
                    borderBottom: `1px solid ${componentsData.content.title_border_color}`,
                }"
            >
                <div
                    class="dec-left"
                    :style="{ background: decLeft }"
                ></div>
                <div
                    class="title-text"
                    :style="{
                        fontSize: `${componentsData.content.title_size}px`,
                        color: componentsData.content.title_color,
                    }"
                >
                    {{ componentsData.content.title || "最近动态" }}
                </div>
                <div
                    class="dec-right"
                    :style="{ background: decRight }"
                ></div>
            </div>

            <!-- 时间轴列表 -->
            <div class="timeline-wrap">
                <div
                    class="timeline-item"
                    v-for="(item, index) in displayList"
                    :key="index"
                >
                    <div class="axis">
                        <!-- 直线加圆点 -->
                        <template v-if="modeId == 1">
                            <div
                                class="dot"
                                :style="{
                                    borderColor:
                                        componentsData.content.circle_color,
                                }"
                            ></div>
                            <div
                                class="line-solid"
                                v-if="index < displayList.length - 1"
                                :style="{
                                    background:
                                        componentsData.content.line_color,
                                }"
                            ></div>
                        </template>
                        <!-- 虚线 -->
                        <template v-else-if="modeId == 2">
                            <div
                                class="line-dash"
                                :style="{
                                    borderLeft: `2px dashed ${componentsData.content.line_color}`,
                                }"
                            ></div>
                        </template>
                        <!-- 直线 -->
                        <template v-else-if="modeId == 3">
                            <div
                                class="line-solid full"
                                :style="{
                                    background:
                                        componentsData.content.line_color,
                                }"
                            ></div>
                        </template>
                        <!-- 直线加图片 -->
                        <template v-else-if="modeId == 4">
                            <img
                                v-if="
                                    componentsData.content.mode_img &&
                                    componentsData.content.mode_img.picview
                                "
                                class="mode-img"
                                :src="
                                    componentsData.content.mode_img.picview
                                "
                            />
                            <div
                                v-else
                                class="dot"
                                :style="{
                                    borderColor:
                                        componentsData.content.circle_color,
                                }"
                            ></div>
                            <div
                                class="line-solid"
                                v-if="index < displayList.length - 1"
                                :style="{
                                    background:
                                        componentsData.content.line_color,
                                }"
                            ></div>
                        </template>
                        <!-- 虚线加图片 -->
                        <template v-else-if="modeId == 5">
                            <img
                                v-if="
                                    componentsData.content.mode_img &&
                                    componentsData.content.mode_img.picview
                                "
                                class="mode-img"
                                :src="
                                    componentsData.content.mode_img.picview
                                "
                            />
                            <div
                                v-else
                                class="dot"
                                :style="{
                                    borderColor:
                                        componentsData.content.circle_color,
                                }"
                            ></div>
                            <div
                                class="line-dash"
                                v-if="index < displayList.length - 1"
                                :style="{
                                    borderLeft: `2px dashed ${componentsData.content.line_color}`,
                                }"
                            ></div>
                        </template>
                    </div>
                    <div class="item-body">
                        <div class="item-head">
                            <div
                                class="item-user"
                                :style="{
                                    fontSize: `${componentsData.content.content_size}px`,
                                    color: componentsData.content
                                        .content_color,
                                }"
                            >
                                {{ item.user }}{{ item.action }}
                            </div>
                            <div class="item-time">{{ item.time }}</div>
                        </div>
                        <div
                            class="item-text"
                            :style="{
                                fontSize: `${componentsData.content.content_size}px`,
                                color: componentsData.content.content_color,
                            }"
                        >
                            {{ item.text }}
                        </div>
                        <div
                            class="media-box"
                            v-if="item.media === 'images'"
                        >
                            <span class="media-tip">多图默认轮播展示</span>
                        </div>
                        <div
                            class="media-box media-video"
                            v-else-if="item.media === 'video'"
                        >
                            <Icon
                                type="ios-play"
                                size="36"
                                color="#666"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 收起/展开按钮 -->
            <div
                class="btn-mask"
                :style="{
                    background: `linear-gradient(transparent, ${componentsData.content.mask_color})`,
                }"
            >
                <div
                    class="collapse-btn"
                    :style="{
                        background: componentsData.content.btn_color,
                        borderColor: componentsData.content.border_color,
                        color: componentsData.content.btn_text_color,
                    }"
                    @click.stop="toggleExpand"
                >
                    {{ expanded ? "点击收起" : "点击展开" }}
                    <Icon
                        :type="expanded ? 'ios-arrow-up' : 'ios-arrow-down'"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const DEMO_LIST = [
    {
        user: "张三",
        action: "填写了记录",
        time: "2024.10.18 12:12",
        text: "填写文案...",
        media: "images",
    },
    {
        user: "张三",
        action: "填写了记录",
        time: "2024.10.18 12:12",
        text: "填写文案...",
        media: "video",
    },
    {
        user: "李四",
        action: "填写了记录",
        time: "2024.10.17 09:30",
        text: "填写文案...",
        media: "images",
    },
];

export default {
    props: {
        componentsData: {
            type: Object,
            default: () => ({}),
            required: true,
        },
    },
    data() {
        return {
            expanded: true,
        };
    },
    computed: {
        modeId() {
            return String(this.componentsData.content.mode_id || "1");
        },
        displayList() {
            return this.expanded ? DEMO_LIST : DEMO_LIST.slice(0, 1);
        },
        decLeft() {
            const color = this.componentsData.content?.dec_color || "#FF761D";
            return `linear-gradient(to left, ${color}, transparent)`;
        },
        decRight() {
            const color = this.componentsData.content?.dec_color || "#FF761D";
            return `linear-gradient(to right, ${color}, transparent)`;
        },
    },
    methods: {
        toggleExpand() {
            this.expanded = !this.expanded;
        },
    },
};
</script>

<style scoped>
.panel {
    overflow: hidden;
    position: relative;
    background: #fff;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.title-row {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 8px;
}
.dec-left,
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.title-text {
    max-width: 200px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.timeline-wrap {
    padding: 12px 0 48px;
}
.timeline-item {
    display: flex;
    align-items: stretch;
}
.axis {
    width: 20px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 4px;
}
.dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 2px solid #ff761d;
    background: #fff;
    box-sizing: border-box;
    flex-shrink: 0;
}
.line-solid {
    width: 2px;
    flex: 1;
    min-height: 20px;
    margin-top: 4px;
    background: #ff761d;
}
.line-solid.full {
    width: 2px;
    flex: 1;
    min-height: 100%;
}
.line-dash {
    flex: 1;
    min-height: 40px;
    width: 0;
}
.mode-img {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}
.item-body {
    flex: 1;
    padding: 0 0 20px 10px;
    min-width: 0;
}
.item-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.item-user {
    font-weight: 500;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.item-time {
    margin-left: 8px;
    font-size: 12px;
    color: #999;
    flex-shrink: 0;
}
.item-text {
    margin-top: 8px;
    line-height: 1.5;
    word-break: break-all;
}
.media-box {
    margin-top: 10px;
    height: 120px;
    background: #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: center;
}
.media-tip {
    color: #ed4014;
    font-size: 14px;
}
.media-video {
    background: #ddd;
}
.btn-mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 28px 0 12px;
    display: flex;
    justify-content: center;
    pointer-events: none;
}
.collapse-btn {
    pointer-events: auto;
    min-width: 120px;
    height: 32px;
    padding: 0 16px;
    border: 1px solid #ff761d;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    cursor: pointer;
    background: #fff;
    color: #ff761d;
}
</style>
